module.exports = __webpack_public_path__ + "static/media/astronomy1.4b0bedbe.jpg";